/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Statements/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import New from './New/index'
import No from 'DesignSystem/VideoRecorderNative/No/index'
import Old from './Old/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Statements({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || ''
let tabSelectedStatementsBetaValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.statements.beta',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: tabSelectedStatementsBetaValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={[].includes(flowValue)}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'New'}>
<New
  viewPath={`${viewPath}/New`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Old'}>
<Old
  viewPath={`${viewPath}/Old`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}